import * as Sentry from '@sentry/react';

/**
 * Helper function to track an errors. This is a wrapper just incase we decide to use a different error tracking service.
 *
 * @param error - The error to track.
 */
export const trackError = (error: unknown) => {
  Sentry.captureException(error);
};
